import { Button, Text } from '@chakra-ui/react';
import Link from 'next/link';
import { FC, ReactNode } from 'react';
import { Trans } from 'react-i18next';

const LogInLink: FC<{ children?: ReactNode }> = ({ children }) => (
  <Link href="/log-in">
    <Button variant="link" ml={2} color="black" type="button">
      {children}
    </Button>
  </Link>
);

export const AlreadyHaveAccount: FC = () => {
  return (
    <Trans
      i18nKey="createAccount.basicInfo.existing"
      components={{
        text: <Text color="gray.600" mt={16} />,
        hyperlink: <LogInLink />,
      }}
    />
  );
};
